import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, CheckIcon, ZapIcon, ShieldAlertIcon, MoonIcon, WalletIcon, BrainIcon, SwordsIcon, BatteryLowIcon, TargetIcon, ArrowRightIcon } from 'lucide-react';
export function OroDetailSection() {
  const contenido = [{
    text: 'Decretos de emergencia listos para usar, cortos y directos, para leer y repetir cuando lo necesitás (sin dar vueltas).'
  }, {
    text: 'Protocolos por situación, organizados por categorías para encontrar rápido "qué hacer" según lo que estés viviendo.'
  }, {
    text: 'Guías express de intervención (paso a paso): qué hacer en el momento, qué sostener durante el día y cómo cerrar la situación para que no se repita.'
  }, {
    text: 'Rutinas cortas de blindaje para cuando sentís el ambiente "pesado", hay discusiones, ansiedad o caída emocional.'
  }, {
    text: 'Sección de dinero/abundancia en crisis: decretos y enfoque para cortar fugas, frenar impulsos y recuperar estabilidad mental para decidir bien.'
  }, {
    text: 'Sección noche/urgencias: decretos específicos para momentos nocturnos o cuando te agarra el bajón/ansiedad y necesitás sostén inmediato.'
  }];
  const situaciones = [{
    icon: SwordsIcon,
    text: 'Cuando aparece una pelea fuerte en casa y querés bajar la tensión rápido.'
  }, {
    icon: BrainIcon,
    text: 'Cuando sentís ansiedad, insomnio o "ruido mental" y necesitás cortar el loop.'
  }, {
    icon: WalletIcon,
    text: 'Cuando se traba lo económico (gastos inesperados, desesperación, impulsividad).'
  }, {
    icon: BatteryLowIcon,
    text: 'Cuando te sentís "sin energía", drenado/a o con sensación de pesadez en el ambiente.'
  }, {
    icon: TargetIcon,
    text: 'Cuando necesitás recuperar foco para volver al protocolo principal sin abandonar.'
  }];
  return <section className="py-12 md:py-24 px-4 bg-primary-bg relative" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-159">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/30 text-gold font-bold text-xs md:text-sm tracking-wider mb-3 md:mb-4" data-id="element-160">
            <FlameIcon className="w-3.5 h-3.5" data-id="element-161" />
            PACK ESPECIAL ORO
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-162">
            ¿Qué vas a adquirir con el Pack Especial Oro?
          </h2>
          <p className="font-body-serif text-sm md:text-base text-text-secondary leading-relaxed max-w-2xl mx-auto" data-id="element-163">
            Al sumar el Pack Especial Oro, te llevás un{' '}
            <span className="font-bold text-text-primary" data-id="element-164">archivo premium</span>{' '}
            diseñado para que, ante una crisis, tengas{' '}
            <span className="font-bold text-text-primary" data-id="element-165">
              palabras + acciones listas para ejecutar en minutos
            </span>
            .
          </p>
        </motion.div>

        {/* Contenido incluido */}
        <div className="bg-card-bg rounded-2xl border border-border-gold shadow-md p-5 md:p-8 mb-5 md:mb-8" data-id="element-166">
          <h3 className="font-heading text-lg md:text-xl font-bold text-text-primary mb-4 md:mb-6 flex items-center gap-2" data-id="element-167">
            <ZapIcon className="w-5 h-5 text-gold" data-id="element-168" />
            Qué incluye
          </h3>
          <div className="space-y-3 md:space-y-4" data-id="element-169">
            {contenido.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-170">
                <div className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-gold/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-171">
                  <CheckIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold" data-id="element-172" />
                </div>
                <p className="text-xs md:text-sm text-text-primary leading-relaxed" data-id="element-173">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>

        {/* Situaciones */}
        <div className="bg-card-bg rounded-2xl border border-border-gold shadow-md p-5 md:p-8 mb-5 md:mb-8" data-id="element-174">
          <h3 className="font-heading text-lg md:text-xl font-bold text-text-primary mb-4 md:mb-6 flex items-center gap-2" data-id="element-175">
            <ShieldAlertIcon className="w-5 h-5 text-gold" data-id="element-176" />
            Situaciones para las que sirve
          </h3>
          <div className="space-y-3 md:space-y-4" data-id="element-177">
            {situaciones.map((item, idx) => {
            const Icon = item.icon;
            return <div key={idx} className="flex items-start gap-3" data-id="element-178">
                  <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-179">
                    <Icon className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-180" />
                  </div>
                  <p className="text-xs md:text-sm text-text-primary leading-relaxed font-medium pt-1.5" data-id="element-181">
                    {item.text}
                  </p>
                </div>;
          })}
          </div>
        </div>

        {/* Mecanismo — Por qué funciona */}
        <div className="bg-gold/5 border-2 border-gold/20 rounded-2xl p-5 md:p-8 mb-5 md:mb-8" data-id="element-182">
          <h3 className="font-heading text-lg md:text-xl font-bold text-gold mb-3 md:mb-4 flex items-center gap-2" data-id="element-183">
            <MoonIcon className="w-5 h-5" data-id="element-184" />
            ¿Por qué este pack marca la diferencia?
          </h3>
          <div className="space-y-3 md:space-y-4 text-sm md:text-base text-text-primary leading-relaxed" data-id="element-185">
            <p data-id="element-186">
              El sistema principal te da el{' '}
              <span className="font-bold" data-id="element-187">camino completo</span>.
            </p>
            <p data-id="element-188">
              El Pack Especial Oro te da el{' '}
              <span className="font-bold text-gold" data-id="element-189">"plan de emergencia"</span>:
            </p>
            <div className="bg-card-bg rounded-xl p-4 border border-gold/20" data-id="element-190">
              <p className="font-body-serif italic text-text-secondary text-sm md:text-base" data-id="element-191">
                Cuando no podés pensar, cuando estás al límite, cuando el día te
                gana →{' '}
                <span className="font-bold not-italic text-text-primary" data-id="element-192">
                  abrís el botiquín, ejecutás, y volvés al control.
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Order Bump CTA */}
        <div className="bg-card-bg rounded-2xl border-2 border-gold shadow-lg p-5 md:p-8 text-center" data-id="element-193">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-194">
            <FlameIcon className="w-5 h-5 text-gold" data-id="element-195" />
            <h3 className="font-heading text-lg md:text-xl font-bold text-text-primary" data-id="element-196">
              Sumá el Pack Especial Oro
            </h3>
          </div>
          <p className="text-xs md:text-sm text-text-secondary mb-4 max-w-lg mx-auto" data-id="element-197">
            Decretos de emergencia + protocolos por crisis (hogar, dinero,
            ansiedad, noche). Ideal para no improvisar cuando te agarra la
            tormenta.
          </p>
          <button onClick={() => {
          const pricing = document.getElementById('pricing');
          if (pricing) pricing.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="btn-cta-pulse w-full md:w-auto px-8 py-3.5 md:py-4 rounded-xl text-base md:text-lg tracking-wide font-bold" data-id="element-198">
            🔥 QUIERO EL PACK ORO
          </button>
        </div>
      </div>
    </section>;
}